import { render, staticRenderFns } from "./memberlist.vue?vue&type=template&id=6502135e&scoped=true&"
import script from "./memberlist.vue?vue&type=script&lang=js&"
export * from "./memberlist.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=6502135e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6502135e",
  null
  
)

export default component.exports